/**
 * Generated runtime TestId mirror for frontend/src/pages/analytics/IdentityGrantsDetail.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const IdentityGrantsDetailTestIds = {
  btnRecalculate: "btn-recalculate",
  cardTitleActiveGrants: "card-title-active-grants",
  cardTitleEffectiveAccessGrants: "card-title-effective-access-grants",
  cardTitleLastCalculated: "card-title-last-calculated",
  cardTitleTotalGrants: "card-title-total-grants",
  colEnforcementObject: "col-enforcement-object",
  colEnvironment: "col-environment",
  colExpand: "col-expand",
  colOperation: "col-operation",
  colResource: "col-resource",
  colSourceAccessProfile: "col-source-access-profile",
  colSourceAssignmentExpires: "col-source-assignment-expires",
  colSourceAssignmentStart: "col-source-assignment-start",
  colSourceCreatedAt: "col-source-created-at",
  colStatus: "col-status",
  colTargetSystem: "col-target-system",
  colValidFrom: "col-valid-from",
  colValidTo: "col-valid-to",
  filterEnvironment: "filter-environment",
  filterSystem: "filter-system",
  identityGrantsDetailPage: "identity-grants-detail-page",
  linkIdentityDetails: "link-identity-details",
  btnExpandGrant: (grant_accessId: string) => `btn-expand-grant-${grant_accessId}`,
  btnExpandGrantPrefix: () => "btn-expand-grant-" as TestIdPrefix,
  linkAccessProfile: (source_sourceId: string) => `link-access-profile-${source_sourceId}`,
  linkAccessProfilePrefix: () => "link-access-profile-" as TestIdPrefix,
  linkEnforcementObject: (grant_accessId: string) => `link-enforcement-object-${grant_accessId}`,
  linkEnforcementObjectPrefix: () => "link-enforcement-object-" as TestIdPrefix,
  linkResource: (grant_accessId: string) => `link-resource-${grant_accessId}`,
  linkResourcePrefix: () => "link-resource-" as TestIdPrefix,
  linkTargetSystem: (grant_accessId: string) => `link-target-system-${grant_accessId}`,
  linkTargetSystemPrefix: () => "link-target-system-" as TestIdPrefix
} as const;
